<div class="feed-dialog-overlay" (click)="onOverlayClick($event)">
  <div class="feed-dialog defaultWindowShape top-left-window-positioning"
    (click)="$event.stopPropagation()">

    <div class="window-header">
      <span class="window-title">Feeds</span>
      <button class="close-button" (click)="closeDialog()">×</button>
    </div>

    <div class="feed-dialog-content">
      <div class="search-container">
        <input
          #searchInput
          id="searchinput"
          class="feeds-search form-control"
          type="text"
          [(ngModel)]="searchQuery"
          placeholder="Filter by feed name"
          (focus)="focusSearch()"
          autofocus>
        </div>

        <div class="feed-list-container">
          <!-- Empty State -->
          @if (filteredFeeds().length === 0) {
            <div class="empty-state">
              <div>
                Click <i class="fa-solid fa-plus" (click)="createNewFeed()"></i> to add a new Feed
              </div>
            </div>
          }

          <!-- Feed List -->
          @if (filteredFeeds().length > 0) {
            <div class="feeds-table-container">
              <table class="table table-striped table-hover">
                <tbody>
                  @for (feed of filteredFeeds(); track feed; let i = $index) {
                    <tr>
                      <td>
                        <div class="center-table-row-item">{{ feed.getName() }}</div>
                      </td>
                      <td>
                        <i class="fa-solid fa-trash"
                          (click)="deleteFeed(i)"
                        title="Delete Feed"></i>
                      </td>
                      <td (click)="feedChangeState(i)">
                        <app-toggle-switch [(ngModel)]="feed.running"></app-toggle-switch>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>

        <!-- Footer Actions -->
        <div class="feed-dialog-footer">
          <i class="fa-solid fa-plus" (click)="createNewFeed()" title="Add Feed"></i>
          <i class="fa-solid fa-trash"  (click)="deleteAllFeeds()" title="Delete All Feeds" [class.disabled]="filteredFeeds().length === 0" [style.pointer-events]="filteredFeeds().length === 0 ? 'none' : 'auto'" [style.opacity]="filteredFeeds().length === 0 ? 0.5 : 1"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Feed Wizard Modal -->
  @if (showWizard()) {
    <app-feed-wizard
      (close)="closeWizard()">
    </app-feed-wizard>
  }